const w = typeof window !== "undefined" ? window : void 0;
const rule = (url) => {
  return {
    isDev: isDev(url),
    isProd: isProd(url),
    isB2B: isB2B(url),
    isB2C: isB2C(url),
    isPublic: isPublic(url),
    isPrivate: isPrivate(url),
    pathEndsWith: (segments) => endsWith(segments, url),
    pathStartsWith: (segments) => startsWith(segments, url),
    pathIncludes: (segments) => includes(segments, url),
    pathMatches: (regexps) => matches(regexps, url),
    pathMatchesExact: (strings) => matchesExact(strings, url)
  };
};
const isDev = (url) => {
  return url.host !== "www.telia.se" && url.host !== "telia.se" || typeof w?.ENVIRONMENT !== "undefined" && w?.ENVIRONMENT === "legacy-dev";
};
const isProd = (url) => url.hostname === "www.telia.se" || url.hostname === "telia.se";
const isB2B = (url) => url.pathname?.startsWith("/foretag");
const isB2C = (url) => !isB2B(url);
const isPublic = (url) => !startsWith(
  ["/privat/mitt-telia", "/mitt-telia", "/foretag/mybusiness", "/foretag/telia-at-work"],
  url
);
const isPrivate = (url) => !isPublic(url);
const startsWith = (segment, url) => segment.some((pathname) => url.pathname.startsWith(pathname));
const endsWith = (segment, url) => segment.some((pathname) => url.pathname.endsWith(pathname));
const includes = (segment, url) => segment.some((pathname) => url.pathname.includes(pathname));
const matches = (regexps, url) => regexps.some((pattern) => pattern.test(url.pathname));
const matchesExact = (strings, url) => strings.some((str) => str === url.pathname);

export { rule };
//# sourceMappingURL=b2x-url-segments.esm.js.map
